import {isNullOrUndefined} from '.';

export function alphabeticalSort(
  itemA: string,
  itemB: string,
  ignoreCase = false
) {
  const itemAComparisonValue = ignoreCase ? itemA : itemA.toLowerCase();
  const itemBComparisonValue = ignoreCase ? itemB : itemB.toLowerCase();

  if (itemAComparisonValue === itemBComparisonValue) {
    return 0;
  }

  if (itemAComparisonValue > itemBComparisonValue) {
    return 1;
  } else {
    return -1;
  }
}

// use this functions if you need to sort and array
// based on a property in object in that array
export function numericSort(
  itemA: string | number | undefined | null,
  itemB: string | number | undefined | null
) {
  if (isNullOrUndefined(itemA) || isNullOrUndefined(itemB)) {
    return 0;
  }

  const itemANumericValue = Number(itemA);
  const itemBNumericValue = Number(itemB);

  if (Number.isNaN(itemANumericValue) || Number.isNaN(itemBNumericValue)) {
    throw new Error('failed to convert value to number');
  }

  if (itemANumericValue === itemBNumericValue) {
    return 0;
  } else {
    if (itemANumericValue > itemBNumericValue) {
      return 1;
    } else {
      return -1;
    }
  }
}

export const sortByDate = (a: string | undefined, b: string | undefined) => {
  if (!a || !b) {
    return 0;
  }
  return new Date(b).getMilliseconds() - new Date(a).getMilliseconds();
};
